import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import Navbar from '../common/Navbar'
import ItWorks from '../subcompo/sections-home/ItWorks';
import Footer from '../common/Footer';
import Loader from '../common/Loader';
import $ from 'jquery';

class HowItWorksBind extends Component {
  componentDidMount() {
    // ReactDOM.findDOMNode(this).scrollTop = 0
    $("html, body").animate({ scrollTop: 0 }, 250);
  }
  render() {
     return (
       <div>
        <Navbar variant="large-logo"/>
        <div className="container">
          <div className="row">
            <div className="col-12">
              <h2 className="text-center">FAQ</h2>
              <p className="text-center">
              </p>
              <p className="secDesc" style={{marginTop: "30px"}}>
                Coming Soon
              </p>
            </div>
          </div>
        </div>
        <ItWorks/>
        <Footer/>
        <Loader/>
      </div>
    );
  }
}

export default HowItWorksBind;
